var exports = {
  "k": "container__Ywox9H",
};

module.exports = exports;
